// @ts-check
// Module core/fix-headers
// Make sure that all h1-h6 headers (that are first direct children of sections) are actually
// numbered at the right depth level. This makes it possible to just use any of them (conventionally
// h2) with the knowledge that the proper depth level will be used
import { renameElement } from "./utils.js";

export const name = "core/fix-headers";

export function run() {
  [...document.querySelectorAll("section")]
    .map(sec => sec.querySelector("h1, h2, h3, h4, h5, h6"))
    .filter(h => h !== null)
    .forEach(heading => {
      const depth = Math.min(getParents(heading, "section").length + 1, 6);
      renameElement(heading, `h${depth}`);
    });
}

/**
 * @param {Element | null} el
 * @param {string} selector
 */
function getParents(el, selector) {
  const parents = [];
  while (el && el != el.ownerDocument.body) {
    if (el.matches(selector)) parents.push(el);
    el = el.parentElement;
  }
  return parents;
}
